import {lazy} from "../../_snowpack/pkg/react.js";
import {generatePath} from "../../_snowpack/pkg/react-router-dom.js";
export const EcdsaGeneratedSettingsRoute = {
  path: "/:realm/realm-settings/keys/providers/:id/ecdsa-generated/settings",
  component: lazy(() => import("../key-providers/ecdsa-generated/ECDSAGeneratedForm.js")),
  breadcrumb: (t) => t("realm-settings:editProvider"),
  access: "view-realm"
};
export const toEcdsaGeneratedSettings = (params) => ({
  pathname: generatePath(EcdsaGeneratedSettingsRoute.path, params)
});
